import type { BillingErrorCode, BillingApiErrorShape } from './types';
import { BillingApiError } from './types';

export const userMessageForErrorCode = (code: BillingErrorCode): string => {
  switch (code) {
    case 'CARD_DECLINED':
      return 'Your card was declined. Try a different card or contact your bank.';
    case 'PAYMENT_TIMEOUT':
      return 'Your payment session expired. Please try again.';
    case 'DUPLICATE_SUBSCRIPTION':
      return 'You already have an active subscription.';
    case 'PLAN_CHANGE_ALREADY_SCHEDULED':
      return 'A plan change is already scheduled. Cancel it before making another change.';
    case 'PLAN_CHANGE_NOT_ALLOWED':
      return 'This plan change is not available right now.';
    case 'NETWORK_ERROR':
      return 'Something went wrong. Your card has not been charged.';
    case 'UPI_PENDING':
      return 'Approve the payment request in your UPI app to complete activation.';
    case 'PLAN_UNAVAILABLE':
      return 'This plan is currently unavailable. Contact support.';
    case 'COUPON_INVALID':
      return 'Invalid or expired coupon.';
    default:
      return 'Payment could not be completed. Please try again.';
  }
};

export const toBillingApiError = (payload: BillingApiErrorShape): BillingApiError => new BillingApiError({
  ...payload,
  message: payload.message || userMessageForErrorCode(payload.code)
});
